import { computed, makeObservable } from 'mobx'
import {
  getComments,
  switchCommentsVisibility,
} from '../../../services/ApiService'
import {
  closeModalFn,
  openModalFn,
} from '../../../utils/controllers/ModalController'
import pagedCollectionStore from '../../../utils/stores/PagedCollectionStore'

class RequestCommentsStore extends pagedCollectionStore {
  constructor({ id }) {
    super({ action: () => getComments(id) })
    this.id = id
    makeObservable(this, {
      isCommentVisible: computed,
    })
  }

  get isCommentVisible() {
    return this.collection.some((el) => !el.isHidden)
  }

  toggleCommentVisible = () => {
    openModalFn['progress-backdrop']()
    switchCommentsVisibility({
      orderId: this.id,
      show: !this.isCommentVisible,
      commentIdList: this.collection.map((el) => el.id),
    })
      .then(() => {
        this.reLoad()
      })
      .finally(() => closeModalFn['progress-backdrop']())
  }
}

export default RequestCommentsStore
